<template>
	
  <div id="box-hulls" :class="['py-5 px-3', 'bk-'+ section]">
    <div class="container">

      <h2 class="text-center mb-5">
        Hulls
      </h2>

      <div class="row justify-content-center text-center">

        <div v-for="(hull, index) in hulls" :key="index" :class="colClass" @click="goToPage(hull.id)">
          <div class="ratio ratio-16x9">
            <div class="previewGallery" :style="'background-image: url('+ ((hull.mainImg) ? hull.mainImg : '') +')'"></div>
          </div>
          <h3 class="my-4" v-html="hullTitle(hull)"></h3>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'YachtHulls',
  props: ['section', 'hulls'],
  computed: {
    colClass() {
        let nHulls = this.hulls.lenght
        let colClass = 'col link'
        if (nHulls == 1) colClass = 'col-12 col-sm-8 link'
        if (nHulls == 2) colClass = 'col-12 col-sm-6 link'
        return colClass
    },
  },
  methods: {
    hullTitle(hull) {
      if (hull.profile) {
        const profile = '<img src="'+ hull.profile +'" alt="'+ hull.title +'" class="title-img mx-3">'
        let hullTitle = hull.title.substring(hull.title.indexOf('/')) 
        return profile + hullTitle
      }
      return hull.title
    },
    goToPage(id) {
        this.$store.dispatch('goToPage', id)
    },
  },
}
</script>
<style scoped>
.ab-yachts h3 {
  font-family: var(--h1-font-family);
  font-size: var(--h1-font-size);
  color: var(--title-font-color);
}
</style>
